import React from 'react';
import PropTypes from 'prop-types';
import api from 'api';
import Component from 'BaseComponent';
import { withRouter, Switch, Route, NavLink, Redirect } from 'react-router-dom';
import Site from 'components/Site';
import Sites from 'components/Sites';
import LogEvents from 'components/LogEvents';
import Account from 'components/Account';
import Auth from 'components/Auth';
import Spinner from 'components/Spinner';
import { skip } from 'ducks/joyride';
import { query } from 'redux-bees';
import autobind from 'autobind-decorator';
import Joyride from 'react-joyride';
import { connect } from 'react-redux';

@withRouter

@query('account', api.getAccount)

@connect(state => ({
  isJoyRideSkipped: state.joyride.skipped,
}))

export default class Backend extends Component {
  static propTypes = {
    status: PropTypes.object.isRequired,
    account: PropTypes.object,
    isJoyRideSkipped: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      stepIndex: 0,
      steps: [],
      autoStart: true,
    };
  }

  @autobind
  addSteps(steps) {
    let newSteps = steps;

    if (!Array.isArray(newSteps)) {
      newSteps = [newSteps];
    }

    if (!newSteps.length) {
      return;
    }

    // Force setState to be synchronous to keep step order.
    this.setState((currentState) => {
      return { ...currentState, steps: currentState.steps.concat(newSteps) };
    });
  }

  @autobind
  resetSteps() {
    this.state = {
      stepIndex: 0,
      steps: [],
      autoStart: true,
    };
  }

  @autobind
  addTooltip(data) {
    this.joyride.addTooltip(data);
  }

  @autobind
  next() {
    this.joyride.next();
  }

  @autobind
  joyrideReset() {
    this.joyride.reset(true);
    this.forceUpdate();
  }

  @autobind
  handleJoyrideCallback(data) {
    const { dispatch } = this.props;

    if (data.action === 'skip' || data.type === 'finished') {
      dispatch(api.skipTour());
      dispatch(skip());
    }
  }

  isSafari() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
  }

  renderBackend() {
    const { account, isJoyRideSkipped } = this.props;
    const { stepIndex, steps, autoStart } = this.state;

    return (
      <div>
        <Joyride
          ref={(c) => { this.joyride = c; }}
          callback={this.handleJoyrideCallback}
          debug={false}
          locale={{
            back: (<span>Back</span>),
            close: (<span>Close</span>),
            last: (<span>Last</span>),
            next: (<span>Next</span>),
            skip: (<span>Skip</span>),
          }}
          run={!isJoyRideSkipped && account && !account.attributes.tourSkipped}
          showOverlay
          autoStart={autoStart}
          showSkipButton
          showStepsProgress={false}
          stepIndex={stepIndex}
          steps={steps}
          type="continuous"
          scrollToSteps={false}
        />
        <div className="TopBar">
          <div className="wrap">
            <div className="TopBar__inner">
              <div className="TopBar__nav">
                <a className="Topbar__logo" href="https://www.hardypress.com">
                  <img src="/assets/images/logo.svg" alt="" height="30" />
                </a>
                <NavLink className="Topbar__link" to="/">
                  Sites
                </NavLink>
                <a className="Topbar__link" href="https://www.hardypress.com/docs/">
                  Docs
                </a>
              </div>
              <div className="TopBar__auth">
                <Auth account={account} />
              </div>
            </div>
          </div>
        </div>
        <div className="Backend">
          <div className="wrap">
            <Switch>
              <Route
                path="/sites"
                render={props => <Sites {...props} />}
              />
              <Route
                path="/site/:id"
                render={
                  props => (
                    <Site
                      {...props}
                      addSteps={this.addSteps}
                      resetSteps={this.resetSteps}
                      joyrideReset={this.joyrideReset}
                    />
                  )
                }
              />
              <Route path="/account" component={Account} />
              <Route path="/logs" component={LogEvents} />
              <Redirect to="/sites" />
            </Switch>
          </div>
        </div>
        <div className="Footer">
          <div className="wrap">
            <div className="Footer__inner">
              <a className="Footer__logo" href="https://www.hardypress.com">
                <img src="/assets/images/horizontal_logo_white.svg" alt="" height="20" />
              </a>
              <div className="Footer__nav">
                <NavLink className="Footer__link" to="/">
                  Sites
                </NavLink>
                <a className="Footer__link" href="https://www.hardypress.com/docs/">
                  Docs
                </a>
                <a className="Footer__link" href="https://status.hardypress.com">
                  System status
                </a>
                <a className="Footer__link" href="https://www.hardypress.com/terms/">
                  Terms
                </a>
                <a className="Footer__link" href="https://www.hardypress.com/contact-us/">
                  Support
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderLoading() {
    return <Spinner size={80} />;
  }

  render() {
    const { status, account } = this.props;

    return (
      <div className="Backend__wrapper">
        {
          status.account.isLoading &&
            this.renderLoading()
        }
        {
          account &&
            this.renderBackend()
        }

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Backend.jsx